import { Dispatch, SetStateAction } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../../components/confirm-modal/ConfirmModal';
import { secondaryBlue } from '../../../utils/color';

type InfoCompleteProfileModalProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  onConfirm?: () => void;
};

const InfoCompleteProfileModal = ({
  isOpen,
  setIsOpen,
  onConfirm,
}: InfoCompleteProfileModalProps) => {
  const navigate = useNavigate();
  const confirm = onConfirm || (() => navigate('../'));
  const { t } = useTranslation();
  return (
    <ConfirmModal
      width="650px"
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      title={t('postRegistration.modal.title')}
      message={
        <Typography color="primaryDark.500" lineHeight="21px" sx={{ py: 3 }}>
          {t('postRegistration.modal.text')}
        </Typography>
      }
      confirmButtonText={t('common.continue')}
      onConfirm={confirm}
      iconProps={{
        icon: <PeopleAltIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
        wrapperBackgroundColor: secondaryBlue[100],
      }}
      onCancel={() => setIsOpen(false)}
    />
  );
};

export default InfoCompleteProfileModal;
